import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { CLIENT_FORM } from '@common/schema/flow';
import { cx } from '@emotion/css';
import { HOME_ROUTES } from '@util/constants';

type Props = {
  step: number;
  stepCount: number;
  onNext: (step: number) => void;
  styles: any;
  problemType?: any | undefined | null;
};

export const GetRemoteQuote = (props: Props) => {
  const { stepCount, styles } = props;
  const problemCatToAvoid = [10, 11, 13, 14, 15, 16];
  const router = useRouter();
  const [isRemoteQuote, setIsRemoteQuote] = useState(false);
  const { watch } = useFormContext();

  const problemType = watch(CLIENT_FORM.PROBLEM_CATEGORY_ID);

  useEffect(() => {
    if (problemType && JSON.parse(problemType)) {
      const problemCategoryId = JSON.parse(problemType).id;
      // check if problemType is in array
      if (problemCategoryId && problemCatToAvoid.includes(problemCategoryId)) {
        setIsRemoteQuote(true);
      } else {
        setIsRemoteQuote(false);
        // check step is greater than stepCount
        props.onNext(stepCount);
      }
    }
  }, [problemType]);

  if (isRemoteQuote) {
    return (
      <div className={cx(styles.f_wrpr, styles.active)}>
        <div className={cx(styles.pricing_txt, styles.text_center)}>
          <h5 className={cx(styles.h5, styles.pricing_head)}>Get a Quote</h5>
          <div className="mt-4" />
          <p className={cx(styles.p, styles.pricing_desc, styles.m_0)}>
            For this type of work, we will need to provide you with an quote
            based on the information provided to us. Please click here to
            request a quote.
          </p>
        </div>
        <div className={cx(styles.f_btn, styles.text_center)}>
          <button
            className={cx(styles.btn_accent, styles.form_btn)}
            onClick={() => router.push(HOME_ROUTES.GET_QUOTE)}>
            Continue to Get Quote
          </button>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
};
